import React, { lazy } from 'react'
import Loadable from 'app/components/Loadable/Loadable'
import { authRoles } from '../../auth/authRoles'

//Lazy loading
const Analytics = Loadable(lazy(() => import('./Analytics')))

const dashboardRoutes = [
    {
        path: '/dashboardddd',
        element: <Analytics />,
        auth: authRoles.forDashboard,
    },
]

export default dashboardRoutes
